import {
    ApartmentOutlined,
    AreaChartOutlined,
    BarChartOutlined,
    FilterFilled,
    HomeFilled,
    SettingFilled,
    TeamOutlined
} from '@ant-design/icons';
import { Menu, MenuProps } from 'antd';
import { observer } from 'mobx-react-lite';
import { useSession } from 'next-auth/react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import useCompanyTimeZone from '../../hooks/adminPage/useCompanyTimeZone';
import { reportRouteStringWithQueryString, reportTypeMap } from '../../layouts/Pages/ReportsLayout';
import { useUtilStore } from '../../store/RootStoreContext';
import { isAdmin } from '../../utils/accountHelper';
import { getSideMenuInitialSelectedKey, guessTimeZone } from '../../utils/helpers';

const SideMenu = () => {
    const { pathname } = useRouter();
    const { t } = useTranslation('common');

    const { lastVisitedFilterPageUrl } = useUtilStore();
    const { data: session } = useSession();
    const { data: zone } = useCompanyTimeZone();
    const userTimeZone = zone ?? guessTimeZone();
    const role = session?.userInfo?.rls?.[0];

    const items: MenuProps['items'] = [
        {
            key: '1',
            icon: <HomeFilled />,
            label: (
                <Link href="/">
                    <a>{t('sideMenu.home')}</a>
                </Link>
            )
        },
        {
            key: '2',
            icon: <FilterFilled />,
            label: (
                <Link href={lastVisitedFilterPageUrl}>
                    <a>{t('sideMenu.filters')}</a>
                </Link>
            )
        },
        {
            key: '5',
            icon: <TeamOutlined />,
            label: <Link href="/users?page=1&size=10">{t('sideMenu.customers')}</Link>
        },
        {
            key: '3',
            icon: <ApartmentOutlined />,
            label: (
                <Link href="/organizations?page=1&size=10">
                    <a>{t('sideMenu.organizations')}</a>
                </Link>
            )
        },
        ...(isAdmin(role)
            ? [
                  {
                      key: '6',
                      icon: <BarChartOutlined />,
                      label: (
                          <Link href={reportRouteStringWithQueryString({}, reportTypeMap.tickets, userTimeZone)}>
                              {t('sideMenu.reports')}
                          </Link>
                      )
                  },
                  {
                      key: '7',
                      icon: <AreaChartOutlined />,
                      label: (
                          <Link href={'/advanced-reports'}>
                              <a>{t('sideMenu.advancedReports')}</a>
                          </Link>
                      )
                  },
                  {
                      key: '4',
                      icon: <SettingFilled />,
                      label: (
                          <Link href="/admin">
                              <a>{t('sideMenu.settings')}</a>
                          </Link>
                      )
                  }
              ]
            : [])
    ];

    return (
        <Menu
            selectedKeys={getSideMenuInitialSelectedKey(pathname)}
            items={items}
            style={{ height: '100%' }}
            mode="inline"
            theme={isAdmin(role) ? 'light' : 'dark'}
            // inlineCollapsed
        />
    );
};

export default observer(SideMenu);
